import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import client, { url } from '../../lib/api/client';
import { uploadImageToServer } from '../../lib/commonFunc/commonFunc';
import axios from 'axios';

const Container = styled.div`
  margin-top: 24px;
  padding-bottom: 40px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const MainTitle = styled.h2`
  margin: 0;
  color: #2c3e50;
  font-size: 1.15rem;
  font-weight: 700;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Body = styled.div`
  padding: 24px;
`;

const MusicListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 6px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f9fbfd;
  }
`;

const MusicInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

const Thumbnail = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  background-color: #f5f7fa;
`;

const NoThumbnail = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background-color: #f5f7fa;
  border: 1px solid #e0e4ea;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${palette.webGray[6]};
  font-size: 11px;
`;

const MusicNumber = styled.span`
  color: ${palette.webGray[6]};
  font-size: 14px;
  font-weight: 600;
  min-width: 30px;
`;

const MusicTitle = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
`;

const MusicUrl = styled.span`
  font-size: 12px;
  color: ${palette.webGray[6]};
  margin-left: 8px;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const AddSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e4ea;
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px 0;
  color: ${palette.webGray[6]};
  font-size: 14px;
`;

const ThumbnailPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PreviewImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e0e4ea;
`;

const extractPlaylistId = (inputUrl) => {
    if (!inputUrl) return inputUrl;
    const match = inputUrl.match(/[?&]list=([a-zA-Z0-9_-]+)/);
    return match ? match[1] : inputUrl;
};

const YOUTUBE_API_KEY = 'AIzaSyAU1Rzat88vvzQvUTh7HQ6NK9mRnpo6XrA';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 700px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
`;

const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid #e0e4ea;
`;

const ChannelInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
`;

const FetchedItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f9fbfd;
  }
`;

const FetchedThumb = styled.img`
  width: 120px;
  height: 68px;
  object-fit: cover;
  border-radius: 6px;
  background-color: #f5f7fa;
  flex-shrink: 0;
`;

const FetchedInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const FetchedTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
`;

const FetchedSub = styled.div`
  font-size: 12px;
  color: ${palette.webGray[6]};
`;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  gap: 12px;
  color: ${palette.webGray[6]};
  font-size: 14px;
`;

const FetchedCount = styled.span`
  font-size: 13px;
  color: ${palette.webGray[6]};
`;

const THUMBNAIL_PATH = 'youtubemusic';
const IMAGE_BASE_URL = 'https://kr.object.ncloudstorage.com/qnoss';

const AdminClubYoutubeMusic = () => {
    const [musicList, setMusicList] = useState([]);
    const [newMusicTitle, setNewMusicTitle] = useState('');
    const [newMusicUrl, setNewMusicUrl] = useState('');
    const [newThumbnailFile, setNewThumbnailFile] = useState(null);
    const [newThumbnailPreview, setNewThumbnailPreview] = useState('');
    const [changed, setChanged] = useState(false);
    const [showFetchModal, setShowFetchModal] = useState(false);
    const [channelInput, setChannelInput] = useState('');
    const [fetchedPlaylists, setFetchedPlaylists] = useState([]);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [selectedFetched, setSelectedFetched] = useState({});
    const fileInputRef = useRef(null);

    useEffect(() => {
        loadMusicList();
    }, []);

    const loadMusicList = async () => {
        try {
            const res = await client.get(`${url}/api/runningtrack/youtubemusic`);
            if (res.data && res.data.result === 1) {
                setMusicList(res.data.infos);
                setChanged(false);
            }
        } catch (e) {
            console.error('음악 목록 로드 실패:', e);
        }
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setNewThumbnailFile(file);
        const reader = new FileReader();
        reader.onload = (ev) => {
            setNewThumbnailPreview(ev.target.result);
        };
        reader.readAsDataURL(file);
    };

    const handleAddMusic = async () => {
        if (newMusicUrl.trim() === '') return;
        try {
            let thumbnailUrl = '';
            if (newThumbnailFile) {
                const filename = `yt_thumb_${Date.now()}.${newThumbnailFile.name.split('.').pop()}`;
                await uploadImageToServer(newThumbnailFile, filename, THUMBNAIL_PATH, newThumbnailFile.type);
                thumbnailUrl = `${IMAGE_BASE_URL}/${THUMBNAIL_PATH}/${filename}`;
            }

            const playlistId = extractPlaylistId(newMusicUrl.trim());
            const res = await client.post(`${url}/api/runningtrack/youtubemusic`, {
                title: newMusicTitle.trim() || '제목 없음',
                url: playlistId,
                thumbnailUrl
            });
            if (res.data && res.data.result === 1) {
                setNewMusicTitle('');
                setNewMusicUrl('');
                setNewThumbnailFile(null);
                setNewThumbnailPreview('');
                if (fileInputRef.current) fileInputRef.current.value = '';
                loadMusicList();
            }
        } catch (e) {
            console.error('음악 추가 실패:', e);
        }
    };

    const handleDeleteMusic = (index) => {
        setMusicList(prev => prev.filter((_, i) => i !== index));
        setChanged(true);
    };

    const handleMoveMusicUp = (index) => {
        if (index === 0) return;
        setMusicList(prev => {
            const newList = [...prev];
            [newList[index - 1], newList[index]] = [newList[index], newList[index - 1]];
            return newList;
        });
        setChanged(true);
    };

    const handleMoveMusicDown = (index) => {
        if (index >= musicList.length - 1) return;
        setMusicList(prev => {
            const newList = [...prev];
            [newList[index], newList[index + 1]] = [newList[index + 1], newList[index]];
            return newList;
        });
        setChanged(true);
    };

    const extractChannelId = (input) => {
        if (!input) return null;
        // UC로 시작하는 채널 ID
        if (/^UC[\w-]{22}$/.test(input.trim())) return input.trim();
        // /channel/UCXXXX 형태
        const channelMatch = input.match(/\/channel\/(UC[\w-]{22})/);
        if (channelMatch) return channelMatch[1];
        // /@handle 형태 -> handle로 검색
        const handleMatch = input.match(/\/@([\w.-]+)/);
        if (handleMatch) return { handle: handleMatch[1] };
        // 그냥 텍스트 -> handle로 검색
        return { handle: input.trim().replace('@', '') };
    };

    const fetchChannelPlaylists = async () => {
        if (!channelInput.trim()) return;
        setFetchLoading(true);
        setFetchedPlaylists([]);
        setSelectedFetched({});
        try {
            let channelId = extractChannelId(channelInput);

            // handle인 경우 채널 ID 먼저 조회
            if (channelId && typeof channelId === 'object' && channelId.handle) {
                const searchRes = await axios.get('https://www.googleapis.com/youtube/v3/search', {
                    params: {
                        part: 'snippet',
                        type: 'channel',
                        q: channelId.handle,
                        maxResults: 1,
                        key: YOUTUBE_API_KEY,
                    }
                });
                if (searchRes.data.items && searchRes.data.items.length > 0) {
                    channelId = searchRes.data.items[0].snippet.channelId;
                } else {
                    alert('채널을 찾을 수 없습니다.');
                    setFetchLoading(false);
                    return;
                }
            }

            // 플레이리스트 목록 가져오기 (페이지네이션)
            let allPlaylists = [];
            let nextPageToken = '';
            do {
                const params = {
                    part: 'snippet,contentDetails',
                    channelId,
                    maxResults: 50,
                    key: YOUTUBE_API_KEY,
                };
                if (nextPageToken) params.pageToken = nextPageToken;

                const res = await axios.get('https://www.googleapis.com/youtube/v3/playlists', { params });
                const items = (res.data.items || []).map(item => ({
                    playlistId: item.id,
                    title: item.snippet.title,
                    description: item.snippet.description,
                    thumbnailUrl: item.snippet.thumbnails?.medium?.url || item.snippet.thumbnails?.default?.url || '',
                    itemCount: item.contentDetails?.itemCount || 0,
                    channelTitle: item.snippet.channelTitle,
                }));
                allPlaylists = [...allPlaylists, ...items];
                nextPageToken = res.data.nextPageToken || '';
            } while (nextPageToken);

            // 필터링: 40개 이하 제거, 제목 없는 리스트 제거, 쇼츠 제거
            const filtered = allPlaylists.filter(pl => {
                if (pl.itemCount < 40) return false;
                if (!pl.title || pl.title.trim() === '') return false;
                const lower = pl.title.toLowerCase();
                if (lower.includes('short') || lower.includes('쇼츠')) return false;
                if (lower.includes('popular right now')) return false;
                if (lower.includes('top tracks')) return false;
                return true;
            });

            setFetchedPlaylists(filtered);
        } catch (e) {
            console.error('플레이리스트 가져오기 실패:', e);
            alert('플레이리스트를 가져오는데 실패했습니다.');
        }
        setFetchLoading(false);
    };

    const toggleFetchedSelect = (playlistId) => {
        setSelectedFetched(prev => {
            const next = { ...prev };
            if (next[playlistId]) {
                delete next[playlistId];
            } else {
                next[playlistId] = true;
            }
            return next;
        });
    };

    const handleSave = async () => {
        try {
            const list = musicList.map(m => ({
                clubYoutubeMusicID: m.clubYoutubeMusicID,
                title: m.title,
                url: m.url,
                thumbnailUrl: m.thumbnailUrl || ''
            }));
            const res = await client.put(`${url}/api/runningtrack/youtubemusic`, { list });
            if (res.data && res.data.result === 1) {
                setChanged(false);
                loadMusicList();
            }
        } catch (e) {
            console.error('음악 목록 저장 실패:', e);
        }
    };

    return (
        <Container>
            <MainTitle>
                <span>유튜브 뮤직 플레이리스트</span>
                <div style={{ display: 'flex', gap: 8 }}>
                    <Button
                        variant="outlined"
                        startIcon={<SearchIcon />}
                        onClick={() => setShowFetchModal(true)}
                    >
                        YouTube에서 가져오기
                    </Button>
                    {changed && (
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<SaveIcon />}
                            onClick={handleSave}
                        >
                            저장
                        </Button>
                    )}
                </div>
            </MainTitle>

            <Body>
            {musicList.length === 0 && (
                <EmptyMessage>
                    등록된 음악이 없습니다. 아래에서 음악을 추가해주세요.
                </EmptyMessage>
            )}
            {musicList.map((music, index) => (
                <MusicListItem key={index}>
                    <MusicInfo>
                        <MusicNumber>{index + 1}</MusicNumber>
                        {music.thumbnailUrl ? (
                            <Thumbnail src={music.thumbnailUrl} alt="" />
                        ) : (
                            <NoThumbnail>No Image</NoThumbnail>
                        )}
                        <div>
                            <MusicTitle>{music.title}</MusicTitle>
                            <br />
                            <MusicUrl>{music.url}</MusicUrl>
                        </div>
                    </MusicInfo>
                    <RightSection>
                        <IconButton
                            size="small"
                            onClick={() => handleMoveMusicUp(index)}
                            disabled={index === 0}
                            style={{ color: palette.webGray[6] }}
                        >
                            <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => handleMoveMusicDown(index)}
                            disabled={index >= musicList.length - 1}
                            style={{ color: palette.webGray[6] }}
                        >
                            <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => handleDeleteMusic(index)}
                            style={{ color: palette.webGray[6] }}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </RightSection>
                </MusicListItem>
            ))}

            <AddSection>
                <ThumbnailPreview>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                    />
                    {newThumbnailPreview ? (
                        <PreviewImage
                            src={newThumbnailPreview}
                            alt=""
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            style={{ cursor: 'pointer' }}
                        />
                    ) : (
                        <IconButton
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            style={{
                                width: 48, height: 48,
                                border: `1px dashed #CDD9ED`,
                                borderRadius: 6
                            }}
                        >
                            <PhotoCameraIcon style={{ color: palette.webGray[6] }} />
                        </IconButton>
                    )}
                </ThumbnailPreview>
                <TextField
                    size="small"
                    label="제목"
                    value={newMusicTitle}
                    onChange={(e) => setNewMusicTitle(e.target.value)}
                    variant="outlined"
                    style={{ width: '200px' }}
                    placeholder="음악 제목"
                />
                <TextField
                    size="small"
                    label="플레이리스트 URL"
                    value={newMusicUrl}
                    onChange={(e) => setNewMusicUrl(e.target.value)}
                    variant="outlined"
                    style={{ flex: 1 }}
                    placeholder="https://music.youtube.com/playlist?list=..."
                />
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleAddMusic}
                    disabled={!newMusicUrl.trim()}
                >
                    추가
                </Button>
            </AddSection>
            </Body>
            {showFetchModal && (
                <Overlay onClick={() => setShowFetchModal(false)}>
                    <Modal onClick={(e) => e.stopPropagation()}>
                        <ModalHeader>
                            <ModalTitle>YouTube 채널에서 플레이리스트 가져오기</ModalTitle>
                            <IconButton size="small" onClick={() => setShowFetchModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </ModalHeader>
                        <ModalBody>
                            <ChannelInputRow>
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="채널 URL 또는 채널 ID 입력"
                                    value={channelInput}
                                    onChange={(e) => setChannelInput(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && fetchChannelPlaylists()}
                                    style={{ flex: 1 }}
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={fetchChannelPlaylists}
                                    disabled={fetchLoading || !channelInput.trim()}
                                    startIcon={<SearchIcon />}
                                >
                                    검색
                                </Button>
                            </ChannelInputRow>

                            {fetchLoading && (
                                <LoadingWrapper>
                                    <CircularProgress size={24} />
                                    플레이리스트를 가져오는 중...
                                </LoadingWrapper>
                            )}

                            {!fetchLoading && fetchedPlaylists.length > 0 && (
                                <>
                                    <FetchedCount>
                                        {fetchedPlaylists.length}개의 플레이리스트 발견
                                        {Object.keys(selectedFetched).length > 0 &&
                                            ` · ${Object.keys(selectedFetched).length}개 선택됨`}
                                    </FetchedCount>
                                    {fetchedPlaylists.map((pl) => (
                                        <FetchedItem
                                            key={pl.playlistId}
                                            onClick={() => toggleFetchedSelect(pl.playlistId)}
                                        >
                                            <Checkbox
                                                checked={!!selectedFetched[pl.playlistId]}
                                                color="primary"
                                                size="small"
                                                style={{ padding: 4 }}
                                            />
                                            <FetchedThumb src={pl.thumbnailUrl} alt="" />
                                            <FetchedInfo>
                                                <FetchedTitle>{pl.title}</FetchedTitle>
                                                <FetchedSub>
                                                    {pl.channelTitle} · {pl.itemCount}개 동영상
                                                </FetchedSub>
                                            </FetchedInfo>
                                        </FetchedItem>
                                    ))}
                                </>
                            )}

                            {!fetchLoading && fetchedPlaylists.length === 0 && channelInput && (
                                <LoadingWrapper style={{ color: palette.webGray[5] }}>
                                    채널 URL을 입력하고 검색 버튼을 눌러주세요.
                                </LoadingWrapper>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={() => setShowFetchModal(false)}>
                                닫기
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Overlay>
            )}
        </Container>
    );
};

export default React.memo(AdminClubYoutubeMusic);
